/**
 * AccessResultStatusBadge.tsx
 *
 * The status of an Access Labs result as a badge: Preliminary, Final or
 * Corrected, in words. A result with no status reads "Received", as a
 * Vibrant row does (VibrantSubTab).
 */
import { Badge } from '@/components/ui';
import { accessStatusLabel, accessStatusVariant } from './accessLabFormat';

interface AccessResultStatusBadgeProps {
  /** 'preliminary' | 'final' | 'corrected' */
  status?: string | null;
  /** "Preliminary" | "Final" | "Corrected" (a row's orcStatus, a detail's statusLabel). */
  label?: string | null;
  size?: 'sm' | 'md';
}

export function AccessResultStatusBadge({ status, label, size = 'sm' }: AccessResultStatusBadgeProps) {
  const text = accessStatusLabel(status, label);
  return (
    <Badge variant={accessStatusVariant(text)} size={size}>
      {text ?? 'Received'}
    </Badge>
  );
}
